import { createTheme } from "@mui/material";

export const DOCUMENT_TYPES = {
  SALES_INVOICE: "SALESINVOICE",
  DELIVERY_ORDER: "DELIVERYORDER",
  SALES_ORDER: "SALESORDER",
  QUOTATION: "QUOTATION",
  SALES_RETURN: "SALESRETURN",
  PURCHASE_INVOICE: "PURCHASEINVOICE",
  PURCHASE_ORDER: "PURCHASEORDER",
  PURCHASE_RETURN: "PURCHASERETURN",
  WORK_ORDER: "WORKORDER",
  SAMPLE_ISSUE: "SAMPLEISSUE",
  SAMPLE_RETURN: "SAMPLERETURN",
  PRODUCTION: "PRODUCTION",
  STOCKTRANSFERIN: "STOCKTRANSFERIN",
  STOCKTRANSFEROUT: "STOCKTRANSFEROUT",
  LOCATION_TRANSFER: "LOCATIONTRANSFER",
  PHYSICAL_STOCK_ENTRY: "PHYSICALSTOCKENTRY",
  GOODS_IN_TRANSIT: "GOODSINTRANSIT",
  BRANCH_TRANSFER: "BRANCHTRANSFER",
  BRANCH_TRANSFER_IN: "BRANCHTRANSFERIN",
  PURCHASE_ENQUIRY: "PURCHASEENQUIRY",

};
export const MODIFICATION_TYPES = {
  [DOCUMENT_TYPES.SALES_INVOICE]: "INVOICETIMELINE",
  [DOCUMENT_TYPES.DELIVERY_ORDER]: "DOTIMELINE",
  [DOCUMENT_TYPES.SALES_ORDER]: "SORDTIMELINE",
  [DOCUMENT_TYPES.QUOTATION]: "QUOTTIMELINE",
  [DOCUMENT_TYPES.PURCHASE_INVOICE]: "PINVTIMELINE",
  [DOCUMENT_TYPES.PURCHASE_ORDER]: "POTIMELINE",
  [DOCUMENT_TYPES.WORK_ORDER]: "WOTIMELINE",
  [DOCUMENT_TYPES.PRODUCTION]: "PRTIMELINE",
};

export const documentConfigs = {
  [DOCUMENT_TYPES.SALES_INVOICE]: {
    title: "Sales Invoice",
    apiEndpoints: {
      save: "/api/SalesInvoiceCrm",
      detail: (companyCode, invoiceNo, department) =>
        `/api/SalesInvoiceDetail/${companyCode}/${invoiceNo}/${department}`,
      transfer: {
        master: (companyCode, department, invoiceNos, docType) =>
          `/api/CRMDocTransfer/${companyCode}/TRANSFER/${docType}MASTER/-/-/${department}/${invoiceNos}/-`,
        detail: (companyCode, department, invoiceNos, docType) =>
          `/api/CRMDocTransfer/${companyCode}/TRANSFER/${docType}DETAIL/-/-/${department}/${invoiceNos}/-`,
      },
    },
    fieldMappings: {
      documentNo: "inv_no",
      documentDate: "inv_date",
      documentTotal: "inv_total",
      documentCost: "inv_cost",
      documentType: "inv_type",
      documentQty: "inv_qty",
      customerAcc: "cust_acc",
      customerRef: "custref",
      altDateKey: "do_date",
      documentFctota: "inv_fctota",
      documentSono: "so_no",
      documentQuotno: "quotno",
      documentInvno: "do_no",
      documentNextAction: "head1",
      documentJvNo: "jv_num",
      refreshType: "SINV",
    },
    defaultValues: {
      documentNo: "",
      paymentType: "cash",
      deliveryType: "CUST_COLLECT",
    },
    features: {
      showReceipt: false,
      showCommission: true,
      showAdvance: true,
      showVAT: true,
      showPaymentModes: true,
      showCashCheckBox: true,
      showTransferModule: true,
    },
  },

  [DOCUMENT_TYPES.DELIVERY_ORDER]: {
    title: "Delivery Order",
    apiEndpoints: {
      save: "/api/DeliveryOrderCrm",
      detail: (companyCode, doNo, department) =>
        `/api/DocumentEditDetails/${companyCode}/DORD/${doNo}/${department}`,
      transfer: {
        master: (companyCode, department, invoiceNos, docType) =>
          `/api/CRMDocTransfer/${companyCode}/TRANSFER/${docType}MASTER/-/-/${department}/${invoiceNos}/-`,
        detail: (companyCode, department, invoiceNos, docType) =>
          `/api/CRMDocTransfer/${companyCode}/TRANSFER/${docType}DETAIL/-/-/${department}/${invoiceNos}/-`,
      },
    },
    fieldMappings: {
      documentNo: "do_no",
      documentDate: "do_date",
      documentTotal: "do_total",
      documentCost: "do_cost",
      documentType: "do_type",
      documentQty: "inv_qty",
      customerAcc: "cust_acc",
      customerRef: "custref",
      altDateKey: "inv_date",
      documentFctota: "inv_fctota",
      documentSono: "so_no",
      documentQuotno: "quotno",
      documentInvno: "inv_no",
      refreshType: "DORD",
    },
    defaultValues: {
      documentNo: "",
      deliveryType: "CUST_COLLECT",
      paymentType: "credit",
    },
    features: {
      showReceipt: false,
      showCommission: false,
      showAdvance: false,
      showVAT: true,
      showPaymentModes: false,
      showCashCheckBox: false,
      showTransferModule: true,
    },
  },
  [DOCUMENT_TYPES.SALES_ORDER]: {
    title: "Sales Order",
    apiEndpoints: {
      save: "/api/SalesOrderCRM",
      detail: (companyCode, orderNo, department) =>
        `/api/DocumentEditDetails/${companyCode}/SORD/${orderNo}/${department}`,

      transfer: {
        master: (companyCode, department, invoiceNos, docType) =>
          `/api/CRMDocTransfer/${companyCode}/TRANSFER/${docType}MASTER/-/-/${department}/${invoiceNos}/-`,
        detail: (companyCode, department, invoiceNos, docType) =>
          `/api/CRMDocTransfer/${companyCode}/TRANSFER/${docType}DETAIL/-/-/${department}/${invoiceNos}/-`,
      },
    },
    fieldMappings: {
      documentNo: "so_no",
      documentDate: "so_date",
      documentTotal: "so_total",
      documentCost: "so_cost",
      documentType: "inv_type",
      documentQty: "inv_qty",
      customerAcc: "cust_acc",
      customerRef: "custref",
      altDateKey: "inv_date",
      documentFctota: "so_fctota",
      documentSono: "qo_no",
      documentQuotno: "quotno",
      documentInvno: "inv_no",
    },
    defaultValues: {
      documentNo: "",
      paymentType: "credit",
      deliveryType: "CUST_COLLECT",
    },
    features: {
      showReceipt: false,
      showCommission: false,
      showAdvance: true,
      showVAT: true,
      showPaymentModes: false,
      showCashCheckBox: false,
      showTransferModule: true,
    },
  },

  [DOCUMENT_TYPES.QUOTATION]: {
    title: "Quotation",
    apiEndpoints: {
      save: "/api/QuotationCRM",
      detail: (companyCode, orderNo, department) =>
        `/api/DocumentEditDetails/${companyCode}/QUOT/${orderNo}/${department}`,
      transfer: {
        master: (companyCode, department, invoiceNos, docType) =>
          `/api/CRMDocTransfer/${companyCode}/TRANSFER/${docType}MASTER/-/-/${department}/${invoiceNos}/-`,
        detail: (companyCode, department, invoiceNos, docType) =>
          `/api/CRMDocTransfer/${companyCode}/TRANSFER/${docType}DETAIL/-/-/${department}/${invoiceNos}/-`,
      },
    },
    fieldMappings: {
      documentNo: "so_no",
      documentDate: "so_date",
      documentTotal: "so_total",
      documentCost: "so_cost",
      documentType: "inv_type",
      documentQty: "inv_qty",
      customerAcc: "cust_acc",
      customerRef: "custref",
      altDateKey: "inv_date",
      documentFctota: "so_fctota",
      documentSono: "qo_no",
      documentQuotno: "leadno",
      documentInvno: "inv_no",
    },
    defaultValues: {
      documentNo: "",
      paymentType: "credit",
      deliveryType: "CUST_COLLECT",
    },
    features: {
      showReceipt: false,
      showCommission: false,
      showAdvance: true,
      showVAT: true,
      showPaymentModes: false,
      showCashCheckBox: false,
      showTransferModule: true,
    },
  },
  [DOCUMENT_TYPES.SALES_RETURN]: {
    title: "Sales Return",
    apiEndpoints: {
      save: "/api/SalesReturnCRM",
      detail: (companyCode, orderNo, department) =>
        `/api/DocumentEditDetails/${companyCode}/SRET/${orderNo}/${department}`,
      invoiceDetail: (companyCode, orderNo, department) =>
        `/api/SalesInvoiceDetail/${companyCode}/${orderNo}/${department}`,
      transfer: {
        master: (companyCode, department, invoiceNos, docType) =>
          `/api/CRMDocTransfer/${companyCode}/TRANSFER/${docType}MASTER/-/-/${department}/${invoiceNos}/-`,
        detail: (companyCode, department, invoiceNos, docType) =>
          `/api/CRMDocTransfer/${companyCode}/TRANSFER/${docType}DETAIL/-/-/${department}/${invoiceNos}/-`,
      },
    },
    fieldMappings: {
      documentNo: "sr_no",
      documentDate: "sr_date",
      documentTotal: "sr_total",
      documentCost: "sr_cost",
      documentType: "inv_type",
      documentQty: "ret_qty",
      customerAcc: "cust_acc",
      customerRef: "custref",
      altDateKey: "do_date",
      documentFctota: "sr_fctota",
      documentSono: "so_no",
      documentQuotno: "quotno",
      documentInvno: "do_no",
      documentLpoNo: "sr_tr_ref",
      documentVehicleNo: "Reason_of_Return",
      documentDriverName: "Condition_of_Part",
      documentDelivSite: "Primary_error",
      documentNextAction: "NextAction",
      documentJvNo: "sr_inv_no",
      refreshType: "SRET",
    },
    defaultValues: {
      documentNo: "",
      paymentType: "credit",
      deliveryType: "",
    },
    features: {
      showReceipt: false,
      showCommission: false,
      showAdvance: false,
      showVAT: true,
      showPaymentModes: false,
      showCashCheckBox: true,
      showTransferModule: true,
    },
  },
  [DOCUMENT_TYPES.PURCHASE_INVOICE]: {
    title: "Pruchase Invoice",
    apiEndpoints: {
      save: "/api/PurchaseInvoiceCRM",
      detail: (companyCode, orderNo, department) =>
        `/api/DocumentEditDetails/${companyCode}/PINV/${orderNo}/${department}`,
      invoiceDetail: (companyCode, orderNo, department) =>
        `/api/SalesInvoiceDetail/${companyCode}/${orderNo}/${department}`,
      transfer: {
        master: (companyCode, department, invoiceNos, docType) =>
          `/api/CRMDocTransfer/${companyCode}/TRANSFER/${docType}MASTER/-/-/${department}/${invoiceNos}/-`,
        detail: (companyCode, department, invoiceNos, docType) =>
          `/api/CRMDocTransfer/${companyCode}/TRANSFER/${docType}DETAIL/-/-/${department}/${invoiceNos}/-`,
      },
    },
    fieldMappings: {
      documentNo: "sr_no",
      documentDate: "sr_date",
      documentTotal: "sr_total",
      documentCost: "sr_cost",
      documentType: "inv_type",
      documentQty: "ret_qty",
      customerAcc: "cust_acc",
      customerRef: "custref",
      altDateKey: "do_date",
      documentFctota: "sr_fctota",
      documentSono: "so_no",
      documentQuotno: "quotno",
      documentInvno: "do_no",
      documentLpoNo: "sr_tr_ref",
      documentVehicleNo: "Reason_of_Return",
      documentDriverName: "Condition_of_Part",
      documentDelivSite: "Primary_error",
      documentNextAction: "NextAction",
      documentJvNo: "sr_inv_no",
      refreshType: "PINV",
    },
    defaultValues: {
      documentNo: "",
      paymentType: "credit",
      deliveryType: "CUST_COLLECT",
    },
    features: {
      showReceipt: false,
      showCommission: false,
      showAdvance: false,
      showVAT: true,
      showPaymentModes: false,
      showCashCheckBox: true,
      showTransferModule: true,
    },
  },
  [DOCUMENT_TYPES.PURCHASE_ORDER]: {
    title: "Pruchase Order",
    apiEndpoints: {
      save: "/api/PurchaseOrderCRM",
      detail: (companyCode, orderNo, department) =>
        `/api/DocumentEditDetails/${companyCode}/PORD/${orderNo}/${department}`,
      invoiceDetail: (companyCode, orderNo, department) =>
        `/api/SalesInvoiceDetail/${companyCode}/${orderNo}/${department}`,
      transfer: {
        master: (companyCode, department, invoiceNos, docType) =>
          `/api/CRMDocTransfer/${companyCode}/TRANSFER/${docType}MASTER/-/-/${department}/${invoiceNos}/-`,
        detail: (companyCode, department, invoiceNos, docType) =>
          `/api/CRMDocTransfer/${companyCode}/TRANSFER/${docType}DETAIL/-/-/${department}/${invoiceNos}/-`,
      },
    },
    fieldMappings: {
      documentNo: "sr_no",
      documentDate: "sr_date",
      documentTotal: "sr_total",
      documentCost: "sr_cost",
      documentType: "inv_type",
      documentQty: "ret_qty",
      customerAcc: "cust_acc",
      customerRef: "custref",
      altDateKey: "do_date",
      documentFctota: "sr_fctota",
      documentSono: "so_no",
      documentQuotno: "quotno",
      documentInvno: "do_no",
      documentLpoNo: "sr_tr_ref",
      documentVehicleNo: "Reason_of_Return",
      documentDriverName: "Condition_of_Part",
      documentDelivSite: "Primary_error",
      documentNextAction: "NextAction",
      documentJvNo: "sr_inv_no",
    },
    defaultValues: {
      documentNo: "",
      paymentType: "credit",
      deliveryType: "CUST_COLLECT",
    },
    features: {
      showReceipt: false,
      showCommission: false,
      showAdvance: false,
      showVAT: true,
      showPaymentModes: false,
      showCashCheckBox: true,
      showTransferModule: true,
    },
  },
  [DOCUMENT_TYPES.PURCHASE_ENQUIRY]: {
    title: "Pruchase Enquiry",
    apiEndpoints: {
      save: "/api/PurchaseEnquiryCRM",
      detail: (companyCode, orderNo, department) =>
        `/api/DocumentEditDetails/${companyCode}/PENQ/${orderNo}/${department}`,
      invoiceDetail: (companyCode, orderNo, department) =>
        `/api/SalesInvoiceDetail/${companyCode}/${orderNo}/${department}`,
      transfer: {
        master: (companyCode, department, invoiceNos, docType) =>
          `/api/CRMDocTransfer/${companyCode}/TRANSFER/${docType}MASTER/-/-/${department}/${invoiceNos}/-`,
        detail: (companyCode, department, invoiceNos, docType) =>
          `/api/CRMDocTransfer/${companyCode}/TRANSFER/${docType}DETAIL/-/-/${department}/${invoiceNos}/-`,
      },
    },
    fieldMappings: {
      documentNo: "sr_no",
      documentDate: "sr_date",
      documentTotal: "sr_total",
      documentCost: "sr_cost",
      documentType: "inv_type",
      documentQty: "ret_qty",
      customerAcc: "cust_acc",
      customerRef: "custref",
      altDateKey: "do_date",
      documentFctota: "sr_fctota",
      documentSono: "so_no",
      documentQuotno: "quotno",
      documentInvno: "do_no",
      documentLpoNo: "sr_tr_ref",
      documentVehicleNo: "Reason_of_Return",
      documentDriverName: "Condition_of_Part",
      documentDelivSite: "Primary_error",
      documentNextAction: "NextAction",
      documentJvNo: "sr_inv_no",
    },
    defaultValues: {
      documentNo: "",
      paymentType: "credit",
      deliveryType: "CUST_COLLECT",
    },
    features: {
      showReceipt: false,
      showCommission: false,
      showAdvance: false,
      showVAT: true,
      showPaymentModes: false,
      showCashCheckBox: true,
      showTransferModule: true,
    },
  },
  [DOCUMENT_TYPES.PURCHASE_RETURN]: {
    title: "Purchase Return",
    apiEndpoints: {
      save: "/api/PurchaseReturnCRM",
      detail: (companyCode, orderNo, department) =>
        `/api/DocumentEditDetails/${companyCode}/PRET/${orderNo}/${department}`,
      invoiceDetail: (companyCode, orderNo, department) =>
        `/api/SalesInvoiceDetail/${companyCode}/${orderNo}/${department}`,
      transfer: {
        master: (companyCode, department, invoiceNos, docType) =>
          `/api/CRMDocTransfer/${companyCode}/TRANSFER/${docType}MASTER/-/-/${department}/${invoiceNos}/-`,
        detail: (companyCode, department, invoiceNos, docType) =>
          `/api/CRMDocTransfer/${companyCode}/TRANSFER/${docType}DETAIL/-/-/${department}/${invoiceNos}/-`,
      },
    },
    fieldMappings: {
      documentNo: "sr_no",
      documentDate: "sr_date",
      documentTotal: "sr_total",
      documentCost: "sr_cost",
      documentType: "inv_type",
      documentQty: "ret_qty",
      customerAcc: "cust_acc",
      customerRef: "custref",
      altDateKey: "do_date",
      documentFctota: "sr_fctota",
      documentSono: "so_no",
      documentQuotno: "quotno",
      documentInvno: "do_no",
      documentLpoNo: "sr_tr_ref",
      documentVehicleNo: "Reason_of_Return",
      documentDriverName: "Condition_of_Part",
      documentDelivSite: "Primary_error",
      documentNextAction: "NextAction",
      documentJvNo: "sr_inv_no",
      refreshType: "PRET",
    },
    defaultValues: {
      documentNo: "",
      paymentType: "credit",
      deliveryType: "CUST_COLLECT",
    },
    features: {
      showReceipt: false,
      showCommission: false,
      showAdvance: false,
      showVAT: true,
      showPaymentModes: false,
      showCashCheckBox: true,
      showTransferModule: true,
    },
  },
  [DOCUMENT_TYPES.WORK_ORDER]: {
    title: "Work Order",
    apiEndpoints: {
      save: "/api/WorkOrderCRM",
      detail: (companyCode, woNo, department) =>
        `/api/DocumentEditDetails/${companyCode}/WORD/${woNo}/${department}`,
      invoiceDetail: (companyCode, orderNo, department) =>
        `/api/SalesInvoiceDetail/${companyCode}/${orderNo}/${department}`,
      transfer: {
        master: (companyCode, department, invoiceNos, docType) =>
          `/api/CRMDocTransfer/${companyCode}/TRANSFER/${docType}MASTER/-/-/${department}/${invoiceNos}/-`,
        detail: (companyCode, department, invoiceNos, docType) =>
          `/api/CRMDocTransfer/${companyCode}/TRANSFER/${docType}DETAIL/-/-/${department}/${invoiceNos}/-`,
      },
    },
    fieldMappings: {
      documentNo: "sr_no",
      documentDate: "sr_date",
      documentTotal: "sr_total",
      documentCost: "sr_cost",
      documentType: "inv_type",
      documentQty: "ret_qty",
      customerAcc: "cust_acc",
      customerRef: "custref",
      altDateKey: "do_date",
      documentFctota: "sr_fctota",
      documentSono: "so_no",
      documentQuotno: "quotno",
      documentInvno: "do_no",
      documentLpoNo: "sr_tr_ref",
      documentVehicleNo: "Reason_of_Return",
      documentDriverName: "Condition_of_Part",
      documentDelivSite: "Primary_error",
      documentNextAction: "NextAction",
      documentJvNo: "sr_inv_no",
    },
    defaultValues: {
      documentNo: "",
      paymentType: "credit",
      deliveryType: "CUST_COLLECT",
    },
    features: {
      showReceipt: false,
      showCommission: false,
      showAdvance: false,
      showVAT: true,
      showPaymentModes: false,
      showCashCheckBox: true,
      showTransferModule: false,
    },
  },
  [DOCUMENT_TYPES.SAMPLE_ISSUE]: {
    title: "Work Order",
    apiEndpoints: {
      save: "/api/SampleIssueCRM",
      detail: (companyCode, woNo, department) =>
        `/api/DocumentEditDetails/${companyCode}/SAMPLEISSUE/${woNo}/${department}`,
      invoiceDetail: (companyCode, orderNo, department) =>
        `/api/SalesInvoiceDetail/${companyCode}/${orderNo}/${department}`,
      transfer: {
        master: (companyCode, department, invoiceNos, docType) =>
          `/api/CRMDocTransfer/${companyCode}/TRANSFER/${docType}MASTER/-/-/${department}/${invoiceNos}/-`,
        detail: (companyCode, department, invoiceNos, docType) =>
          `/api/CRMDocTransfer/${companyCode}/TRANSFER/${docType}DETAIL/-/-/${department}/${invoiceNos}/-`,
      },
    },
    fieldMappings: {
      documentNo: "sr_no",
      documentDate: "sr_date",
      documentTotal: "sr_total",
      documentCost: "sr_cost",
      documentType: "inv_type",
      documentQty: "ret_qty",
      customerAcc: "cust_acc",
      customerRef: "custref",
      altDateKey: "do_date",
      documentFctota: "sr_fctota",
      documentSono: "so_no",
      documentQuotno: "quotno",
      documentInvno: "do_no",
      documentLpoNo: "sr_tr_ref",
      documentVehicleNo: "Reason_of_Return",
      documentDriverName: "Condition_of_Part",
      documentDelivSite: "Primary_error",
      documentNextAction: "NextAction",
      documentJvNo: "sr_inv_no",
    },
    defaultValues: {
      documentNo: "",
      paymentType: "credit",
      deliveryType: "CUST_COLLECT",
    },
    features: {
      showReceipt: false,
      showCommission: false,
      showAdvance: false,
      showVAT: true,
      showPaymentModes: false,
      showCashCheckBox: false,
      showTransferModule: true,
    },
  },
  [DOCUMENT_TYPES.LOCATION_TRANSFER]: {
    title: "Location Transfer",
    apiEndpoints: {
      save: "/api/CRMLocationTransfer",
      detail: (companyCode, woNo, department) =>
        `/api/DocumentEditDetails/${companyCode}/LOC/${woNo}/${department}`,
      invoiceDetail: (companyCode, orderNo, department) =>
        `/api/SalesInvoiceDetail/${companyCode}/${orderNo}/${department}`,
      transfer: {
        master: (companyCode, department, invoiceNos, docType) =>
          `/api/CRMDocTransfer/${companyCode}/TRANSFER/${docType}MASTER/-/-/${department}/${invoiceNos}/-`,
        detail: (companyCode, department, invoiceNos, docType) =>
          `/api/CRMDocTransfer/${companyCode}/TRANSFER/${docType}DETAIL/-/-/${department}/${invoiceNos}/-`,
      },
    },
    fieldMappings: {
      documentNo: "sr_no",
      documentDate: "sr_date",
      documentTotal: "sr_total",
      documentCost: "sr_cost",
      documentType: "inv_type",
      documentQty: "ret_qty",
      customerAcc: "cust_acc",
      customerRef: "custref",
      altDateKey: "do_date",
      documentFctota: "sr_fctota",
      documentSono: "so_no",
      documentQuotno: "quotno",
      documentInvno: "do_no",
      documentLpoNo: "sr_tr_ref",
      documentVehicleNo: "Reason_of_Return",
      documentDriverName: "Condition_of_Part",
      documentDelivSite: "Primary_error",
      documentNextAction: "NextAction",
      documentJvNo: "sr_inv_no",
      refreshType: "LT",
    },
    defaultValues: {
      documentNo: "",
      paymentType: "credit",
      deliveryType: "CUST_COLLECT",
    },
    features: {
      showReceipt: false,
      showCommission: false,
      showAdvance: false,
      showVAT: true,
      showPaymentModes: false,
      showCashCheckBox: false,
      showTransferModule: true,
    },
  },
  [DOCUMENT_TYPES.PHYSICAL_STOCK_ENTRY]: {
    title: "Physical Stock Entry",
    apiEndpoints: {
      save: "/api/CRMLocationTransfer",
      detail: (companyCode, woNo, department) =>
        `/api/DocumentEditDetails/${companyCode}/SAMPLEISSUE/${woNo}/${department}`,
      invoiceDetail: (companyCode, orderNo, department) =>
        `/api/SalesInvoiceDetail/${companyCode}/${orderNo}/${department}`,
      transfer: {
        master: (companyCode, department, invoiceNos, docType) =>
          `/api/CRMDocTransfer/${companyCode}/TRANSFER/${docType}MASTER/-/-/${department}/${invoiceNos}/-`,
        detail: (companyCode, department, invoiceNos, docType) =>
          `/api/CRMDocTransfer/${companyCode}/TRANSFER/${docType}DETAIL/-/-/${department}/${invoiceNos}/-`,
      },
    },
    fieldMappings: {
      documentNo: "sr_no",
      documentDate: "sr_date",
      documentTotal: "sr_total",
      documentCost: "sr_cost",
      documentType: "inv_type",
      documentQty: "ret_qty",
      customerAcc: "cust_acc",
      customerRef: "custref",
      altDateKey: "do_date",
      documentFctota: "sr_fctota",
      documentSono: "so_no",
      documentQuotno: "quotno",
      documentInvno: "do_no",
      documentLpoNo: "sr_tr_ref",
      documentVehicleNo: "Reason_of_Return",
      documentDriverName: "Condition_of_Part",
      documentDelivSite: "Primary_error",
      documentNextAction: "NextAction",
      documentJvNo: "sr_inv_no",
    },
    defaultValues: {
      documentNo: "",
      paymentType: "credit",
      deliveryType: "CUST_COLLECT",
    },
    features: {
      showReceipt: false,
      showCommission: false,
      showAdvance: false,
      showVAT: true,
      showPaymentModes: false,
      showCashCheckBox: false,
      showTransferModule: true,
    },
  },
  [DOCUMENT_TYPES.SAMPLE_RETURN]: {
    title: "Work Order",
    apiEndpoints: {
      save: "/api/SampleIssueCRM",
      detail: (companyCode, woNo, department) =>
        `/api/DocumentEditDetails/${companyCode}/SAMPLERETURN/${woNo}/${department}`,
      invoiceDetail: (companyCode, orderNo, department) =>
        `/api/SalesInvoiceDetail/${companyCode}/${orderNo}/${department}`,
      transfer: {
        master: (companyCode, department, invoiceNos, docType) =>
          `/api/CRMDocTransfer/${companyCode}/TRANSFER/${docType}MASTER/-/-/${department}/${invoiceNos}/-`,
        detail: (companyCode, department, invoiceNos, docType) =>
          `/api/CRMDocTransfer/${companyCode}/TRANSFER/${docType}DETAIL/-/-/${department}/${invoiceNos}/-`,
      },
    },
    fieldMappings: {
      documentNo: "sr_no",
      documentDate: "sr_date",
      documentTotal: "sr_total",
      documentCost: "sr_cost",
      documentType: "inv_type",
      documentQty: "ret_qty",
      customerAcc: "cust_acc",
      customerRef: "custref",
      altDateKey: "do_date",
      documentFctota: "sr_fctota",
      documentSono: "so_no",
      documentQuotno: "quotno",
      documentInvno: "do_no",
      documentLpoNo: "sr_tr_ref",
      documentVehicleNo: "Reason_of_Return",
      documentDriverName: "Condition_of_Part",
      documentDelivSite: "Primary_error",
      documentNextAction: "NextAction",
      documentJvNo: "sr_inv_no",
    },
    defaultValues: {
      documentNo: "",
      paymentType: "credit",
      deliveryType: "CUST_COLLECT",
    },
    features: {
      showReceipt: false,
      showCommission: false,
      showAdvance: false,
      showVAT: false,
      showPaymentModes: false,
      showCashCheckBox: false,
      showTransferModule: true,
    },
  },
  [DOCUMENT_TYPES.PRODUCTION]: {
    title: "Production",
    apiEndpoints: {
      save: "/api/ProductionCRM",
      detail: (companyCode, orderNo, department) =>
        `/api/DocumentEditDetails/${companyCode}/PINV/${orderNo}/${department}`,
      invoiceDetail: (companyCode, orderNo, department) =>
        `/api/SalesInvoiceDetail/${companyCode}/${orderNo}/${department}`,
      transfer: {
        master: (companyCode, department, invoiceNos, docType) =>
          `/api/CRMDocTransfer/${companyCode}/TRANSFER/${docType}MASTER/-/-/${department}/${invoiceNos}/-`,
        detail: (companyCode, department, invoiceNos, docType) =>
          `/api/CRMDocTransfer/${companyCode}/TRANSFER/${docType}DETAIL/-/-/${department}/${invoiceNos}/-`,
      },
    },
    fieldMappings: {
      documentNo: "sr_no",
      documentDate: "sr_date",
      documentTotal: "sr_total",
      documentCost: "sr_cost",
      documentType: "inv_type",
      documentQty: "ret_qty",
      customerAcc: "cust_acc",
      customerRef: "custref",
      altDateKey: "do_date",
      documentFctota: "sr_fctota",
      documentSono: "so_no",
      documentQuotno: "quotno",
      documentInvno: "do_no",
      documentLpoNo: "sr_tr_ref",
      documentVehicleNo: "Reason_of_Return",
      documentDriverName: "Condition_of_Part",
      documentDelivSite: "Primary_error",
      documentNextAction: "NextAction",
      documentJvNo: "sr_inv_no",
    },
    defaultValues: {
      documentNo: "",
      paymentType: "credit",
      deliveryType: "CUST_COLLECT",
    },
    features: {
      showReceipt: false,
      showCommission: false,
      showAdvance: false,
      showVAT: true,
      showPaymentModes: false,
      showCashCheckBox: true,
      showTransferModule: true,
    },
  },
  [DOCUMENT_TYPES.STOCKTRANSFERIN]: {
    title: "Stock Transfer In",
    apiEndpoints: {
      save: "/api/StockTransferCRM",
      detail: (companyCode, orderNo, department) =>
        `/api/DocumentEditDetails/${companyCode}/TRANSFERIN/${orderNo}/${department}`,
      invoiceDetail: (companyCode, orderNo, department) =>
        `/api/SalesInvoiceDetail/${companyCode}/${orderNo}/${department}`,
      transfer: {
        master: (companyCode, department, invoiceNos, docType) =>
          `/api/CRMDocTransfer/${companyCode}/TRANSFER/${docType}MASTER/-/-/${department}/${invoiceNos}/-`,
        detail: (companyCode, department, invoiceNos, docType) =>
          `/api/CRMDocTransfer/${companyCode}/TRANSFER/${docType}DETAIL/-/-/${department}/${invoiceNos}/-`,
      },
    },
    fieldMappings: {
      documentNo: "sr_no",
      documentDate: "sr_date",
      documentTotal: "sr_total",
      documentCost: "sr_cost",
      documentType: "inv_type",
      documentQty: "ret_qty",
      customerAcc: "cust_acc",
      customerRef: "custref",
      altDateKey: "do_date",
      documentFctota: "sr_fctota",
      documentSono: "so_no",
      documentQuotno: "quotno",
      documentInvno: "do_no",
      documentLpoNo: "sr_tr_ref",
      documentVehicleNo: "Reason_of_Return",
      documentDriverName: "Condition_of_Part",
      documentDelivSite: "Primary_error",
      documentNextAction: "NextAction",
      documentJvNo: "sr_inv_no",
    },
    defaultValues: {
      documentNo: "",
      paymentType: "credit",
      deliveryType: "CUST_COLLECT",
    },
    features: {
      showReceipt: false,
      showCommission: false,
      showAdvance: false,
      showVAT: true,
      showPaymentModes: false,
      showCashCheckBox: true,
      showTransferModule: true,
    },
  },
  [DOCUMENT_TYPES.STOCKTRANSFEROUT]: {
    title: "Stock Transfer Out",
    apiEndpoints: {
      save: "/api/StockTransferCRM",
      detail: (companyCode, orderNo, department) =>
        `/api/DocumentEditDetails/${companyCode}/TRANSFEROUT/${orderNo}/${department}`,
      invoiceDetail: (companyCode, orderNo, department) =>
        `/api/SalesInvoiceDetail/${companyCode}/${orderNo}/${department}`,
      transfer: {
        master: (companyCode, department, invoiceNos, docType) =>
          `/api/CRMDocTransfer/${companyCode}/TRANSFER/${docType}MASTER/-/-/${department}/${invoiceNos}/-`,
        detail: (companyCode, department, invoiceNos, docType) =>
          `/api/CRMDocTransfer/${companyCode}/TRANSFER/${docType}DETAIL/-/-/${department}/${invoiceNos}/-`,
      },
    },
    fieldMappings: {
      documentNo: "sr_no",
      documentDate: "sr_date",
      documentTotal: "sr_total",
      documentCost: "sr_cost",
      documentType: "inv_type",
      documentQty: "ret_qty",
      customerAcc: "cust_acc",
      customerRef: "custref",
      altDateKey: "do_date",
      documentFctota: "sr_fctota",
      documentSono: "so_no",
      documentQuotno: "quotno",
      documentInvno: "do_no",
      documentLpoNo: "sr_tr_ref",
      documentVehicleNo: "Reason_of_Return",
      documentDriverName: "Condition_of_Part",
      documentDelivSite: "Primary_error",
      documentNextAction: "NextAction",
      documentJvNo: "sr_inv_no",
    },
    defaultValues: {
      documentNo: "",
      paymentType: "credit",
      deliveryType: "CUST_COLLECT",
    },
    features: {
      showReceipt: false,
      showCommission: false,
      showAdvance: false,
      showVAT: true,
      showPaymentModes: false,
      showCashCheckBox: true,
      showTransferModule: true,
    },
  },
  [DOCUMENT_TYPES.GOODS_IN_TRANSIT]: {
    title: "Pruchase Order",
    apiEndpoints: {
      save: "/api/PurchaseOrderCRM",
      detail: (companyCode, orderNo, department) =>
        `/api/DocumentEditDetails/${companyCode}/PORD/${orderNo}/${department}`,
      invoiceDetail: (companyCode, orderNo, department) =>
        `/api/SalesInvoiceDetail/${companyCode}/${orderNo}/${department}`,
      transfer: {
        master: (companyCode, department, invoiceNos, docType) =>
          `/api/CRMDocTransfer/${companyCode}/TRANSFER/${docType}MASTER/-/-/${department}/${invoiceNos}/-`,
        detail: (companyCode, department, invoiceNos, docType) =>
          `/api/CRMDocTransfer/${companyCode}/TRANSFER/${docType}DETAIL/-/-/${department}/${invoiceNos}/-`,
      },
    },
    fieldMappings: {
      documentNo: "sr_no",
      documentDate: "sr_date",
      documentTotal: "sr_total",
      documentCost: "sr_cost",
      documentType: "inv_type",
      documentQty: "ret_qty",
      customerAcc: "cust_acc",
      customerRef: "custref",
      altDateKey: "do_date",
      documentFctota: "sr_fctota",
      documentSono: "so_no",
      documentQuotno: "quotno",
      documentInvno: "do_no",
      documentLpoNo: "sr_tr_ref",
      documentVehicleNo: "Reason_of_Return",
      documentDriverName: "Condition_of_Part",
      documentDelivSite: "Primary_error",
      documentNextAction: "NextAction",
      documentJvNo: "sr_inv_no",
    },
    defaultValues: {
      documentNo: "",
      paymentType: "credit",
      deliveryType: "CUST_COLLECT",
    },
    features: {
      showReceipt: false,
      showCommission: false,
      showAdvance: false,
      showVAT: true,
      showPaymentModes: false,
      showCashCheckBox: true,
      showTransferModule: true,
    },
  },
  [DOCUMENT_TYPES.BRANCH_TRANSFER]: {
    title: "Branch Transfer",
    apiEndpoints: {
      save: "/api/BranchTransferCRM",
      detail: (companyCode, orderNo, department) =>
        `/api/DocumentEditDetails/${companyCode}/BTOUT/${orderNo}/${department}`,
      invoiceDetail: (companyCode, orderNo, department) =>
        `/api/SalesInvoiceDetail/${companyCode}/${orderNo}/${department}`,
      transfer: {
        master: (companyCode, department, invoiceNos, docType) =>
          `/api/CRMDocTransfer/${companyCode}/TRANSFER/${docType}MASTER/-/-/${department}/${invoiceNos}/-`,
        detail: (companyCode, department, invoiceNos, docType) =>
          `/api/CRMDocTransfer/${companyCode}/TRANSFER/${docType}DETAIL/-/-/${department}/${invoiceNos}/-`,
      },
    },
    fieldMappings: {
      documentNo: "sr_no",
      documentDate: "sr_date",
      documentTotal: "sr_total",
      documentCost: "sr_cost",
      documentType: "inv_type",
      documentQty: "ret_qty",
      customerAcc: "cust_acc",
      customerRef: "custref",
      altDateKey: "do_date",
      documentFctota: "sr_fctota",
      documentSono: "so_no",
      documentQuotno: "quotno",
      documentInvno: "do_no",
      documentLpoNo: "sr_tr_ref",
      documentVehicleNo: "Reason_of_Return",
      documentDriverName: "Condition_of_Part",
      documentDelivSite: "Primary_error",
      documentNextAction: "NextAction",
      documentJvNo: "sr_inv_no",
    },
    defaultValues: {
      documentNo: "",
      paymentType: "credit",
      deliveryType: "CUST_COLLECT",
    },
    features: {
      showReceipt: false,
      showCommission: false,
      showAdvance: false,
      showVAT: true,
      showPaymentModes: false,
      showCashCheckBox: true,
      showTransferModule: true,
    },
  },
  [DOCUMENT_TYPES.BRANCH_TRANSFER_IN]: {
    title: "Branch Transfer In",
    apiEndpoints: {
      save: "/api/BranchTransferCRM",
      detail: (companyCode, orderNo, department) =>
        `/api/DocumentEditDetails/${companyCode}/BTin/${orderNo}/${department}`,
      invoiceDetail: (companyCode, orderNo, department) =>
        `/api/SalesInvoiceDetail/${companyCode}/${orderNo}/${department}`,
      transfer: {
        master: (companyCode, department, invoiceNos, docType) =>
          `/api/CRMDocTransfer/${companyCode}/TRANSFER/${docType}MASTER/-/-/${department}/${invoiceNos}/-`,
        detail: (companyCode, department, invoiceNos, docType) =>
          `/api/CRMDocTransfer/${companyCode}/TRANSFER/${docType}DETAIL/-/-/${department}/${invoiceNos}/-`,
      },
    },
    fieldMappings: {
      documentNo: "sr_no",
      documentDate: "sr_date",
      documentTotal: "sr_total",
      documentCost: "sr_cost",
      documentType: "inv_type",
      documentQty: "ret_qty",
      customerAcc: "cust_acc",
      customerRef: "custref",
      altDateKey: "do_date",
      documentFctota: "sr_fctota",
      documentSono: "so_no",
      documentQuotno: "quotno",
      documentInvno: "do_no",
      documentLpoNo: "sr_tr_ref",
      documentVehicleNo: "Reason_of_Return",
      documentDriverName: "Condition_of_Part",
      documentDelivSite: "Primary_error",
      documentNextAction: "NextAction",
      documentJvNo: "sr_inv_no",
    },
    defaultValues: {
      documentNo: "",
      paymentType: "credit",
      deliveryType: "CUST_COLLECT",
    },
    features: {
      showReceipt: false,
      showCommission: false,
      showAdvance: false,
      showVAT: true,
      showPaymentModes: false,
      showCashCheckBox: true,
      showTransferModule: true,
    },
  },
};

export const STOCK_TRANSFER_CONFIG = {
  STOCKTRANSFERIN: {
    title: "Transfer In",
    apiPath: "IN",
    glSettingKeys: {
      debit: "IN-STK-D",
      credit: "IN-STK-C",
    },
    accountDirection: {
      drAccount: "salespersonAcc",
      crAccount: "glSetting",
    },
  },
  STOCKTRANSFEROUT: {
    title: "Transfer Out",
    apiPath: "OT",
    glSettingKeys: {
      debit: "OT-STK-D",
      credit: "OT-STK-C",
    },
    accountDirection: {
      drAccount: "glSetting",
      crAccount: "salespersonAcc",
    },
  },
  BRANCHTRANSFER: {
    title: "Branch Transfer",
    apiPath: "SI",
    glSettingKeys: {
      debit: "OT-STK-D",
      credit: "SI-STK-C",
    },
    accountDirection: {
      drAccount: "salespersonAcc",
      crAccount: "glSetting",
    },
  },
  BRANCHTRANSFERIN: {
    title: "Branch Transfer In",
    apiPath: "BT",
    glSettingKeys: {
      debit: "BT-IN-D",
      credit: "BT-IN-C",
    },
    accountDirection: {
      drAccount: "salespersonAcc",
      crAccount: "glSetting",
    },
  },
};
export const getDocumentConfig = (documentType) => {
  return (
    documentConfigs[documentType] ||
    documentConfigs[DOCUMENT_TYPES.SALES_INVOICE]
  );
};

// Helper to map component state to API payload
export const mapStateToApiPayload = (stateData, items, documentType) => {
  const config = getDocumentConfig(documentType);
  const fieldMap = config.fieldMappings;

  return items.map((item, idx) => ({
    // Common fields for all document types
    cmpcode: stateData.COMPANY_CODE,
    modeop: stateData.isEdit ? "EDIT" : "SAVE",

    // Map document-specific fields using field mappings
    [fieldMap.documentNo]: stateData.documentNo || "",
    [fieldMap.documentDate]: stateData.date || "",
    [fieldMap.documentTotal]: stateData.totalAmount || "0",
    [fieldMap.customerAcc]: stateData.customerAccount || "0",

    Slno: idx + 1,
    code: item.code || "",
    description: item.description || "",
    qty: item.qty?.toString() || "",
    unit: item.unit || "",

    ...(config.features.showReceipt && {
      rcvd_mode1: stateData.receiptData?.rcvd_mode1 || "",
      rcvd_mode1_acc: stateData.receiptData?.rcvd_mode1_acc || "",
    }),

    ...(config.features.showCommission && {
      commi_acc_Dr: stateData.receiptData?.commissionExpense || "",
      commi_acc_Cr: stateData.receiptData?.commissionPayable || "",
    }),
  }));
};

// To Fetch Document Number
export const fetchDocumentNumber = async (
  documentType,
  customerType = "cash",
  BASE_URL,
  COMPANY_CODE,
  DEPARTMENT,
) => {
  try {
    const countRes = await fetch(
      `${BASE_URL}/api/CpaysCount/${COMPANY_CODE}/COMPANYINFO/-/-`,
    );
    const countData = await countRes.json();

    const invSerial = countData?.[0]?.inv_serial === true;

    console.log("inv_serial value:", invSerial);
    console.log("Requested documentType:", documentType);

    let voucherType = null;

    switch (documentType) {
      case DOCUMENT_TYPES.SALES_INVOICE:
        if (invSerial) {
          voucherType = customerType === "cash" ? "IS-CA" : "IS-CR";
        } else {
          // If inv_serial is FALSE, use the default "IS"
          voucherType = "IS";
        }
        break;

      case DOCUMENT_TYPES.DELIVERY_ORDER:
        voucherType = "DO";
        break;

      case DOCUMENT_TYPES.SALES_ORDER:
        voucherType = "SO";
        break;

      case DOCUMENT_TYPES.QUOTATION:
        voucherType = "QT";
        break;

      case DOCUMENT_TYPES.SALES_RETURN:
        voucherType = "SR";
        break;

      case DOCUMENT_TYPES.PURCHASE_INVOICE:
        voucherType = "IR";
        break;

      case DOCUMENT_TYPES.PURCHASE_ORDER:
        voucherType = "PO";
        break;

      case DOCUMENT_TYPES.WORK_ORDER:
        voucherType = "EST";
        break;

      case DOCUMENT_TYPES.SAMPLE_ISSUE:
        voucherType = "DM-I";
        break;

      case DOCUMENT_TYPES.LOCATION_TRANSFER:
        voucherType = "LT";
        break;

      case DOCUMENT_TYPES.SAMPLE_RETURN:
        voucherType = "DM-R";
        break;
      case DOCUMENT_TYPES.PRODUCTION:
        voucherType = "FP";
        break;
      case DOCUMENT_TYPES.STOCKTRANSFERIN:
        voucherType = "IN";
        break;
      case DOCUMENT_TYPES.STOCKTRANSFEROUT:
        voucherType = "OT";
        break;
      case DOCUMENT_TYPES.PHYSICAL_STOCK_ENTRY:
        voucherType = "PH-Q";
        break;
      case DOCUMENT_TYPES.GOODS_IN_TRANSIT:
        voucherType = "GI";
        break;
      case DOCUMENT_TYPES.BRANCH_TRANSFER:
        voucherType = "BO";
        break;
      case DOCUMENT_TYPES.BRANCH_TRANSFER_IN:
        voucherType = "BI";
        break;
      case DOCUMENT_TYPES.PURCHASE_RETURN:
        voucherType = "PR";
        break;
      case DOCUMENT_TYPES.PURCHASE_ENQUIRY:
        voucherType = "PE";
        break;

      default:
        voucherType = null;
    }

    if (!voucherType) {
      console.warn("No voucherType resolved");
      return { voucherType: null, documentNo: null };
    }

    console.log("Final voucherType:", voucherType);

    const voucherRes = await fetch(
      `${BASE_URL}/api/CRMVoucherSettings/${COMPANY_CODE}/VOUCHERNUMBERS/${DEPARTMENT}/GET/${voucherType}/-`,
    );

    const voucherData = await voucherRes.json();
    const documentNo = voucherData?.[0]?.NEXT_NO ?? null;

    return { voucherType, documentNo };
  } catch (err) {
    console.error("Error fetching document number:", err);
    return { voucherType: null, documentNo: null };
  }
};

export const theme = createTheme({
  typography: {
    fontFamily: `'Figtree', sans-serif`,
  },
});
export const tooltipContent = (
  <div style={{ whiteSpace: "pre-line", fontSize: "0.875rem", maxWidth: 250 }}>
    <strong className="block mb-1">Keyboard Shortcuts</strong>
    <ol className="list-decimal list-inside space-y-1">
      <li>
        <span className="font-semibold">F2</span> — Open <u>Supplier List</u>{" "}
        when the <strong>search input</strong> is focused
      </li>
      <li>
        <span className="font-semibold">F2</span> — Open <u>Product List</u>{" "}
        when the <strong>table</strong> is focused
      </li>
      <li>
        <span className="font-semibold">Esc</span> — Close Modal or Cancel
      </li>
    </ol>
  </div>
);

// Fetch unit options for items
export const fetchUnitOptionsForItems = async (
  items,
  BASE_URL,
  COMPANY_CODE,
) => {
  const unitOptionsMap = {};
  for (const item of items) {
    if (item.code) {
      const safeProductCode = encodeURIComponent(item.code);
      const url = `${BASE_URL}/api/CpaysCount/${COMPANY_CODE}/UNITS/${safeProductCode}/-`;
      try {
        const res = await fetch(url);
        const data = await res.json();
        unitOptionsMap[item.id] = data.map((u) => ({
          value: u.Unit,
          label: u.Unit,
        }));
        if (!item.unit && unitOptionsMap[item.id].length > 0) {
          item.unit = unitOptionsMap[item.id][0].value;
        }
      } catch (err) {
        unitOptionsMap[item.id] = [];
      }
    }
  }
  return unitOptionsMap;
};
